import { useState, useEffect } from "react";
import * as firebase from "firebase";

import { getNextExercise } from "utils/exerciseScheduling";
import { useAuth } from "hooks/useAuth";

export function useNextExercise() {
  const [exerciseData, setExerciseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { trials, exercises } = useAuth();

  useEffect(() => {
    if (trials && exercises) {
      setExerciseData(getNextExercise(exercises, trials, {}));
      setLoading(false);
    }
  }, [trials, exercises]);

  const exercise = !!exerciseData ? exerciseData.exercise : null;

  function submitAnswer({ answer, responseTime, startTimestamp }) {
    const isCorrect = answer === exercise.answer;
    const trial = {
      exerciseId: exercise.id,
      answer,
      isCorrect,
      responseTime,
      userId: firebase.auth().currentUser.uid,
      startTimestamp,
      endTimestamp: new Date(),
      created: firebase.firestore.FieldValue.serverTimestamp()
    };

    setLoading(true);
    setExerciseData(null);
    setError(false);

    firebase.firestore().collection("trials").add(trial);
  }

  return {
    error,
    loading,
    exerciseData,
    submitAnswer
  };
}
